
export class Draft {
    id: number;
    jsonString: string;
    name: string;
    transaction: string;
    userId: number;
    version: number;
}

export class DraftRequest {
    request: string;    // load or save
    draft: Draft;
}
